<template>
  <div class="contentD">
    <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
             label-width="150px">
      <div class="pageTitle">消息设置</div>
      <div class="minTitle">审核通知</div>
      <el-form-item label="审核通知：" prop="auditNotification">
        <el-radio-group v-model="searchForm.auditNotification">
          <el-radio label="0">开启</el-radio>
          <el-radio label="1">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="searchForm.auditNotification != 1" label="通知方式：" prop="auditMethod">
        <el-checkbox-group v-model="searchForm.auditMethod">
          <el-checkbox label="0">系统提醒</el-checkbox>
          <el-checkbox label="1">手机短信</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="审核结果通知：" prop="resultNotice">
        <el-radio-group v-model="searchForm.resultNotice">
          <el-radio label="0">开启</el-radio>
          <el-radio label="1">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="searchForm.resultNotice != 1" label="通知方式：" prop="resultMehtods">
        <el-checkbox-group v-model="searchForm.resultMehtods">
          <el-checkbox label="0">系统提醒</el-checkbox>
          <el-checkbox label="1">手机短信</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div class="minTitle">资源借阅</div>
      <el-form-item label="到期提醒通知：" prop="resourceBorrow">
        <el-radio-group v-model="searchForm.resourceBorrow">
          <el-radio label="0">开启</el-radio>
          <el-radio label="1">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="minTitle">用户修改密码提醒</div>
      <el-form-item label="定期修改密码提醒：" prop="changePassword">
        <el-radio-group v-model="searchForm.changePassword">
          <el-radio label="0">开启</el-radio>
          <el-radio label="1">关闭</el-radio>
        </el-radio-group>
        <div v-show="searchForm.changePassword == 0">
          <el-radio-group v-model="monthRadio" @input="searchForm.configValue = ''">
            <el-radio label="one">间隔3个月</el-radio>
            <el-radio label="two">间隔半年</el-radio>
            <el-radio label="three">自定义</el-radio>
          </el-radio-group>
          <el-input v-show="monthRadio == 'three'" style="width: 100px;margin-left: 15px"
                    v-model="searchForm.configValue" @input="setBorrowDays('configValue')" maxlength="2" clearable
                    placeholder="1~12月"></el-input>
        </div>
      </el-form-item>
    </el-form>
    <div class="infoPageBtn">
      <el-button type="primary" @click="saveData()" size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "setInfo",
  data() {
    return {
      searchForm: {
        auditNotification: '1',
        auditMethod: [],
        resultNotice: '1',
        resultMehtods: [],
        resourceBorrow: '1',
        changePassword: '1',

        configValue: '0',
      },
      monthRadio: 'one',
      allData: {},
      rules: {},
      dataInform:{},
    }
  },

  mounted() {
    this.getDataDetail()
  },

  methods: {
    getDataDetail() {
      this.searchForm.auditMethod = []
      this.searchForm.resultMehtods = []
      this.$axios(this.api.allCommon.commonMessageSettingGetByMessageType, {}, 'post').then(data => {
        if (data && data.status) {
          this.allData = data.data
          data.data.forEach(item => {
            if (item.notificationType == '0') {
              this.searchForm.auditNotification = item.remind
              if (item.phoneReminder == 0) {
                this.searchForm.auditMethod.push('1')
              }
              if (item.systemReminder == 0) {
                this.searchForm.auditMethod.push('0')
              }
            }
            if (item.notificationType == '1') {
              this.searchForm.resultNotice = item.remind
              if (item.phoneReminder == 0) {
                this.searchForm.resultMehtods.push('1')
              }
              if (item.systemReminder == 0) {
                this.searchForm.resultMehtods.push('0')
              }
            }
            if (item.notificationType == '2') {
              this.searchForm.resourceBorrow = item.remind
            }
            if (item.notificationType == '3') {
              this.searchForm.changePassword = item.remind
            }
          })
        }
      })
      this.$axios(this.api.user.getUserPasswordChangeReminder).then((res) => {
        if (res.status) {
          this.dataInform = res.data
          this.searchForm.configValue = res.data.configValue
          if (res.data.configValue == '3') {
            this.monthRadio = 'one'
          } else if (res.data.configValue == '6') {
            this.monthRadio = 'two'
          } else {
            this.monthRadio = 'three'
          }
        }
        this.loading = false
      })
    },

    //只能输入大于0的正整数
    setBorrowDays(formName) {
      let setValue = this.searchForm[formName] + ''
      setValue = setValue.replace(/[^0-9]/g, "")
      if (setValue * 1 > 12) {
        setValue = 12
      }
      if (setValue * 1 == 0) {
        setValue = 1
      }
      this.$nextTick(()=>{
        this.searchForm[formName] = setValue
      })
    },

    //修改消息设置
    saveData() {
      this.allData.forEach(item => {
        if (item.notificationType == '0') {
          item.remind = this.searchForm.auditNotification
          item.systemReminder = '1'
          item.phoneReminder = '1'
          this.searchForm.auditMethod.forEach(itemRow => {
            if (itemRow == '0') {
              item.systemReminder = '0'
            }
            if (itemRow == '1') {
              item.phoneReminder = '0'
            }
          })
        }
        if (item.notificationType == '1') {
          item.remind = this.searchForm.resultNotice
          item.systemReminder = '1'
          item.phoneReminder = '1'
          this.searchForm.resultMehtods.forEach(itemRow => {
            if (itemRow == '0') {
              item.systemReminder = '0'
            }
            if (itemRow == '1') {
              item.phoneReminder = '0'
            }
          })
        }
        if (item.notificationType == '2') {
          item.remind = this.searchForm.resourceBorrow
        }
        if (item.notificationType == '3') {
          item.remind = this.searchForm.changePassword
        }
      })
      if (this.monthRadio == 'three' && this.searchForm.changePassword == '0'){
        if (this.searchForm.configValue != '0' && !this.searchForm.configValue){
          this.$message.error('请输入修改密码间隔时间!')
          return
        }
      }
      this.$axios(this.api.allCommon.commonMessageSettingUpdateByType, this.allData, 'put').then(data => {
        if (data && data.status) {
          let configValue = this.searchForm.configValue
          if (this.monthRadio == 'one') {
            configValue = '3'
          }
          if (this.monthRadio == 'two') {
            configValue = '6'
          }
          this.dataInform.configValue = configValue
          this.$axios(this.api.user.systemConfig, this.dataInform, 'put').then((res) => {
            if (res && res.status) {
              this.$message.success('保存成功')
              this.getDataDetail()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
  },
}
</script>

<style scoped>
.contentD {
  padding: 15px;
  overflow-y: auto;
}

.pageTitle {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}

.minTitle {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 5px;
}

.infoPageBtn {
  margin-top: 50px;
  margin-left: 180px;
}
</style>